import { ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScrollToBottomFABProps {
  visible: boolean;
  onClick: () => void;
  isMobile?: boolean;
}

const ScrollToBottomFAB = ({ visible, onClick, isMobile }: ScrollToBottomFABProps) => (
  <button
    onClick={onClick}
    className={cn(
      "absolute left-1/2 -translate-x-1/2 h-9 w-9 rounded-full bg-white shadow-lg border border-gray-200",
      "flex items-center justify-center text-gray-500 hover:text-primary transition-all z-10",
      "duration-200 ease-in-out",
      isMobile ? "bottom-2" : "bottom-4",
      visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none",
    )}
    aria-label="Scroll to bottom"
  >
    <ArrowDown className="h-4 w-4" />
  </button>
);

export default ScrollToBottomFAB;
